import { Save } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, ButtonGroup, Modal, Typography } from '@mui/material';

interface creationModal {
  modalOpen: any;
  setModalOpen: any;
  children: any;
  handleSubmit: any;
  title: string;
}
export default function CreationModal(props: creationModal) {
  const { modalOpen, setModalOpen, handleSubmit, title, children } = props;
  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        style={{
          backgroundColor: 'white',
          position: 'absolute',
          top: 'calc(50% - 250px)',
          left: 'calc(50% - 338px)',
          width: '676px',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '5px',
        }}
      >
        <Typography
          variant="h4"
          style={{ marginTop: '1rem', marginLeft: '1rem' }}
        >
          {title}
        </Typography>
        <form>
          {children}
          <ButtonGroup
            style={{ boxShadow: '0px 0px 0px' }}
            variant="contained"
            size="medium"
          >
            <Button
              startIcon={<Save />}
              onClick={handleSubmit}
              style={{
                backgroundColor: '#0288d1',
                marginLeft: '1rem',
                marginBottom: '2rem',
              }}
            >
              <span>Publicar</span>
            </Button>
            <Button
              startIcon={<CloseIcon />}
              onClick={() => setModalOpen(false)}
              style={{ backgroundColor: '#dd4b39', marginBottom: '2rem' }}
            >
              <span>Sair</span>
            </Button>
          </ButtonGroup>
        </form>
      </Box>
    </Modal>
  );
}
